module.exports = __webpack_public_path__ + "img/pool-8-ball.aeaa7214.svg";